'use client';
import { useEffect, useState } from 'react';
// import './experience.scss';
// import { ExperienceRoot } from '@contentful/experiences-sdk-react';
// trigger component registration
import '../../registeredComponents';

// trigger design tokens registration
import '../../registeredTokens';
import Spinner from '@/components/Spinner';
import dynamic from 'next/dynamic';
// import { draftMode } from 'next/headers';
// import { getData } from '@/actions/page.action';
import AOS from "aos";
import { getLocale, setDefaultLocale, setLocale, setLocales } from '@/config/app.config';
import Cookies from 'js-cookie';
import SectionAutoTracker from '@/components/SectionAutoTracker';

const ExperienceRoot = dynamic(
    () => import('@contentful/experiences-sdk-react').then(mod => mod.ExperienceRoot),
    {
        ssr: false,         // Avoid server-side rendering (it's a browser-only SDK)
        loading: () => <Spinner />, // Show this while loading
    }
);

interface ExperienceProps {
    experienceJSON: string | null;
    locale: string;
    selectedTheme?: string;
    localeList?: string[];
    defaultLocale?: string;
}

// Dynamic components import
const Exp = ({ experienceJSON, selectedTheme = "livat", locale, localeList = [], defaultLocale = getLocale() }: ExperienceProps) => {
    const [loading, setLoading] = useState(true);
    const [loadExp, setLoadExp] = useState(false);
    useEffect(() => {
        let idleId: number;

        if (typeof window !== "undefined") {
            if(document.readyState) {
                setLoadExp(true);
            }
        }

        const initAOS = () => {
            AOS.init({
                duration: 800,
                once: true,
                startEvent: "DOMContentLoaded",
                disableMutationObserver: true,
            });
        };

        if ("requestIdleCallback" in window) {
            idleId = (window as any).requestIdleCallback(initAOS);
        } else {
            setTimeout(initAOS, 1200);
        }

        return () => {
            if ("cancelIdleCallback" in window) {
                (window as any).cancelIdleCallback(idleId);
            }
        };
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 20);
    }, [experienceJSON]);
    useEffect(() => {
        // console.log("selectedTheme ------", selectedTheme)
        if (selectedTheme) {
            const body: any = window.document.querySelector("body");
            body.className = body?.getAttribute("data-class") + " " + selectedTheme?.toLowerCase();
        }
    }, [selectedTheme]);

    useEffect(() => {
        setLocales(localeList);
        setDefaultLocale(defaultLocale);
        // console.log("Exp ---- ", locale, localeList, defaultLocale)

        Cookies.set('BP_LOCALE_LIST', localeList?.join(','));
        // , {
        //     path: "/",
        //     httpOnly: false,
        //     sameSite: "lax",
        //     maxAge: 60 * 60 * 24 * 30, // 30 days
        // });
        Cookies.set('BP_DEFAULT_LOCALE', defaultLocale);
        // , {
        //     path: "/",
        //     httpOnly: false,
        //     sameSite: "lax",
        //     maxAge: 60 * 60 * 24 * 30, // 30 days
        // } );

        if (localeList.includes(locale)) {
            setLocale(locale);
            Cookies.set('NEXT_LOCALE', locale);
        }

    }, [localeList, locale])

    return (
        <>
            {loading ?
                <>
                    <Spinner loading={true} timer={500} />
                </>
                :
                <>
                    {/* {locale} */}
                    {loadExp && 
                        <>
                            {experienceJSON && 
                                <SectionAutoTracker selector=".track-section">
                                    <ExperienceRoot experience={experienceJSON} locale={locale} />
                                </SectionAutoTracker>
                            }
                        </>
                    }
                </>
            }
        </>
    );
};

export default Exp;